
import NotifyHelper from 'src/boot/NotifyHelper';
import Objectives from 'src/boot/services/Objectives';
import {
  defineComponent,
  PropType,
  ref,
  computed,
  inject,
  Ref,
  defineAsyncComponent,
  watch,
} from 'vue';
import { Objective } from '../../types';

export default defineComponent({
  name: 'ObjectiveBody',
  components: {
    ObjectiveTitle: defineAsyncComponent(() => import('./ObjectiveTitle.vue')),
    ObjectiveItem: defineAsyncComponent(() => import('./ObjectiveItem.vue')),
    LoadingContainer: defineAsyncComponent(
      () => import('../layout/LoadingContainer.vue')
    ),
  },
  props: {
    objective: {
      type: Object as PropType<Objective>,
      required: true,
    },
    qNumeration: {
      type: Number,
      require: false,
    },
    feedback: {
      type: Boolean,
      default: false,
    },
    answer: {
      type: String,
      default: '',
    },
    context: {
      type: String,
      default: 'objective',
    },
  },
  setup(props, context) {
    const loading = inject('loading', ref(false)) as Ref<boolean>;
    const isPaused = inject('isPaused', ref(false)) as Ref<boolean>;
    const delayQuiz = inject('delayQuiz', ref(false)) as Ref<boolean>;
    const currentQuestion = inject('currentQuestion', ref(0)) as Ref<
      Objective | number
    >;
    const marked = ref(props.answer);

    const sendReport = async (msg: string) => {
      try {
        await Objectives.sendReport(msg, props.objective)
        NotifyHelper.notifySuccess('Enviado com sucesso.')
      } catch (error) {
        console.error(error)
      }
    }

    const setResponse = (letter: string) => {
      marked.value = marked.value === letter ? '' : letter;
      context.emit('answer', marked.value);
    };

    const showComments = computed(() => {
      return props.feedback && props.objective.bestcomment;
    });

    const alternatives = computed(() => {
      return Object.keys(props.objective.alternatives).sort();
    });

    watch(currentQuestion, () => {
      marked.value = '';
    });

    return {
      loading,
      showComments,
      marked,
      alternatives,
      isPaused,
      delayQuiz,
      sendReport,
      setResponse,
    };
  },
});
